import React, { Component } from 'react';
import styled from 'styled-components';
import { Flex, Box } from 'grid-styled';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import footerLogo from 'images/footerLogo.svg';
import Container from 'partials/Container';
import api from 'api';
import SmartLink from 'partials/SmartLink';
import WP from 'WP';

class Footer extends Component {

    constructor() {
        super();

        this.state = {
            menu: null
        }
    }

    componentWillMount() {
        api.getMenuById(WP.footer_menu_id)
            .then(res => {
                //console.log('FOOTER MENU: ',res);
                if(res.data.items && res.data.items[0]) {
                    this.setState({ menu: res.data.items });
                }
            })
            .catch(e => console.log('Failed to load footer menu', e));
    }

    _blured() {
        const max768 = window.matchMedia("(max-width: 768px)").matches;
        return this.props.searchBlur && !max768 ? 'blured blured-on-search' : 'blured-on-search';
    }

    render() {
        const date = new Date();
        const { menu } = this.state;

        return (
            <Wrapper className={'route-transition-state-'+this.props.routeTransitionState}>
                <Container>
                    <Flex justify="space-between" wrap className={this._blured.bind(this)()}>

                        <Logo flex={1}>
                            <NavLink to={WP.lang === 'en' ? '/en' : '/'}>
                                <img src={WP.assets+footerLogo} alt="HLM logo"/>
                            </NavLink>
                        </Logo>

                        <Menu>
                            <Copy>&copy; {date.getFullYear()} HLM Arkitektur</Copy>
                            <Nav>
                                {menu && menu.map((item, i) => {
                                    return (
                                        <li key={i}>
                                            <SmartLink to={item.url} activeClassName="active" >{item.title}</SmartLink>
                                        </li>
                                    )
                                })}
                            </Nav>
                        </Menu>
                        
                        {WP.options &&
                            <Social flex={1} justify="flex-end">
                                <a href={WP.options.facebook_link} target="_blanlk" title="Facebook">Facebook</a> 
                                <a href={WP.options.instagram_link} target="_blanlk" title="Instagram">Instagram</a>
                            </Social>
                        }

                    </Flex>
                </Container>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        searchBlur: state.searchBlur,
        routeTransitionState: state.routeTransitionState,
    }
}

export default withRouter(connect(mapStateToProps, null)(Footer));

const Wrapper = styled.footer`
    padding: 35px 0 50px;
    &.route-transition-state-enter {
        opacity:0;
    }
    @media (max-width:768px) {
        padding: 30px 0 25px;
    }
`

const Logo = styled(Flex)`
    @media (max-width:768px) {
        width: 100%;
        display: block;
        flex: auto;
        margin-bottom: 25px;
    }
    a {
        border-bottom: none;
    }
`
const Menu = styled(Box)`
    @media (max-width:768px) {
        width:100%;
    }
`
const Social = styled(Flex)`
    a {
        margin-left: 5px;
        font-size:14px;
        height:20px;
    }
    @media (max-width:768px) {
        display:none;
    }
`
const Copy = styled.span`
    font-size:14px;
    display:block;
`

const Nav = styled.ul`
    li {
        display: inline;
        position: relative;
        &:after {
            content: '';
            width: 10px;
            margin: 0 6px;
            height:1px;
            background: #797979;
            display: inline-block;
            position: relative;
            top: -3px;
        }
        &:last-child:after {
            display:none;
        }
        a {
            color: #797979;
            font-size:14px;
            border-bottom-color: #9e9e9e;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/Footer.js